const pasoInitialState = {
  paso: {
    data: "Home",
    anterior: "",
  },
  circuito: null,
};

export default pasoInitialState;
